import { Injectable } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ThunderstormService {

  constructor(private utilService: UtilsService) { }

  setRainfallData(data, adminSelected, route) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      // if (adminSelected) {
      //   locName = this.utilService.formatNames(data[item]['name']);
      // } else {
      //   locName = this.utilService.formatNames(data[item]['name']);
      // }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1) };
        }
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object['District'] = { val: locName };
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = { val: locName };
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false);
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setRainfallDataWeekly(data, adminSelected, route, type) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      // if (adminSelected) {
      //   locName = this.utilService.formatNames(data[item]['name']);
      // } else {
      //   locName = this.utilService.formatNames(data[item]['name']);
      // }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          if (type == 'mean') {
            object[element['timeStamp']] = { val: Number(element['data']['mnRf']).toFixed(1) };
          }
          else if (type == 'median') {
            object[element['timeStamp']] = { val: Number(element['data']['mdRf']).toFixed(1) };
          }
        }
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object['District'] = { val: locName };
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = { val: locName };
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false);
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  createColumns(columns, adminSelected, isMandal) {
    const finalColumns = [];
    if (adminSelected) {
      if (isMandal) {
        finalColumns.push({
          val: 'Mandal',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Mandal'
        });
      }
      finalColumns.push({
        val: 'District',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'District'
      });
    } else {
      if (isMandal) {
        finalColumns.push({
          val: 'Sub Basin',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'SubBasin'
        });
      }
      finalColumns.push({
        val: 'Basin',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Basin'
      });
    }
    for (const element in columns) {
      finalColumns.push({
        val: columns[element],
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: columns[element]
      });
    }
    return finalColumns;
  }

  createColumnsVillage(columns, adminSelected, isVillage) {
    let finalColumns = [];
    if (adminSelected) {
      if (isVillage) {
        finalColumns.push({
          val: 'Village',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Village'
        })
      }
      finalColumns.push({
        val: 'Mandal',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Mandal'
      })
    }
    for (let element in columns) {
      finalColumns.push({
        val: columns[element],
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: columns[element]
      })
    }
    return finalColumns;
  }

  setBlockArray(data, route) {
    let rainfallDataKeys;
    for (const item of Object.keys(data)) {
      rainfallDataKeys = [];
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '6hr') {
          rainfallDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '24hr') {
          rainfallDataKeys.push('24hr');
        } else {
          rainfallDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(rainfallDataKeys, route);
  }

  setMandalData(data, adminSelected, route) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = { val: locName };
        object['District'] = { val: pName };
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = { val: locName };
        object['Basin'] = { val: pName };
      }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1) };
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setVillageData(data, adminSelected, route) {
    let finalData = {};
    let tableDataMandal = [];
    for (let item of Object.keys(data)) {
      let object = [];
      let locName = '';
      let pName = '';
      pName = this.utilService.formatNames(data[item]['pName']);
      locName = this.utilService.formatNames(data[item]['name']);
      object['Village'] = {
        val: locName
      };
      object['Mandal'] = {
        val: pName
      };
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1) };
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal

    let tableColumns = [];
    let cols = this.createColumnsVillage(this.setBlockArray(data, route), true, true)
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setWeeklyMandalData(data, adminSelected, route, type) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = { val: locName };
        object['District'] = { val: pName };
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = { val: locName };
        object['Basin'] = { val: pName };
      }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          if (type == 'mean') {
            object[element['timeStamp']] = { val: Number(element['data']['mnRf']).toFixed(1) };
          } else if (type == 'median') {
            object[element['timeStamp']] = { val: Number(element['data']['mdRf']).toFixed(1) };
          }
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setChartData(data, ProjConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  formatDataForChart(data) {
    const chartData = {};
    for (const range of Object.keys(data)) {
      const obj = {};
      for (const item of Object.keys(data[range])) {
        if (item == '6hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[range][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        }
      }
      chartData[range] = obj;
    }
    return chartData;
  }

  sortKeys(data, route) {
    const returnArray = [];
    let dummyArray = [];
    for (const timestamp of data) {

      if (route.snapshot.paramMap.get('time') == '24' && timestamp == '24hr') {
        returnArray.push(timestamp);
      } else {
        dummyArray.push(timestamp);
      }
    }
    dummyArray = dummyArray.sort();
    for (const ele of dummyArray) {
      returnArray.push(ele);
    }
    return returnArray;
  }

  get24HrsTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 4; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 21600000);
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    blocks[4] = {};
    blocks[4]['timeStamp'] = blocks[0]['timeStamp'];
    blocks[4]['timeLineName'] = {};
    blocks[4]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[0]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[0]['timeStamp']);
    blocks[4]['timeLineName']['label'] = '24hr';
    blocks[4]['leftSideName'] = '24hr';
    blocks[4]['timeLinePos'] = 4;
    return blocks;
  }

  setAccurayData(data, loctype) {
    const finalData = {};
    const timeStampList = [];
    let table_data = [];
    const locationname = loctype == 'BLOCK' ? 'Mandal' : (loctype == 'VILLAGE' ? 'Village' : 'District');
    Object.keys(data).forEach(locId => {
      // console.log(locId)
      const locObject = {};
      locObject[locationname] = { val: this.utilService.formatNames(data[locId]['locName']), id: locId };
      locObject['raf'] = { val: (data[locId]['accuracyData']['arf']).toFixed(3) };
      Object.keys(data[locId]['accuracyData']['ad']).forEach(element => {
        const elemnt = element;
        if (!timeStampList.includes(elemnt)) {
          timeStampList.push(elemnt);
        }

        // console.log(elemnt)
        const forecast = data[locId]['accuracyData']['ad'][elemnt]['rfv'];
        const accuray = data[locId]['accuracyData']['ad'][elemnt]['rfa'];
        let cumm_accuracy = data[locId]['accuracyData']['ad'][elemnt]['rfca'];
        locObject[elemnt + '_forecast'] = { val: forecast.toFixed(3) };
        locObject[elemnt + '_accuracy'] = { val: accuray.toFixed(3) };
        locObject[elemnt + '_cummulative_accuracy'] = { val: cumm_accuracy.toFixed(3) };
      });
      if (data[locId]['lat'] && data[locId]['lon']) {
        locObject['centroid'] = { 'lat': data[locId]['lat'], 'lon': data[locId]['lon'] };
      }
      table_data.push(locObject);
    });

    const sortedTimeStampList = timeStampList.sort();
    const column1 = [];
    column1.push({
      val: locationname,
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: locationname,
    });
    column1.push({
      val: 'Actual (mm)',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'raf',
    });
    const column2 = [];
    const tableHeaders = [];
    tableHeaders.push({ val: locationname });
    tableHeaders.push({ val: 'raf' });

    for (const index in sortedTimeStampList) {
      const tp = sortedTimeStampList[index];
      // console.log(tp)
      column1.push({
        val: (tp.replace(/_/g, ' ')).toUpperCase(),
        colspan: 3,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + '_d'
      });
      column2.push({
        val: 'Forecast (mm)',
        colspan: 1,
        rowspan: 1,
        backgroundColor: null,
        sortedHeaderVal: tp.toString() + '_forecast'
      });
      column2.push({
        val: 'Accuracy (%)',
        colspan: 1,
        rowspan: 1,
        backgroundColor: null,
        sortedHeaderVal: tp.toString() + '_accuracy'
      });
      column2.push({
        val: 'Cummulative Accuracy (%)',
        colspan: 1,
        rowspan: 1,
        backgroundColor: null,
        sortedHeaderVal: tp.toString() + '_cummulative_accuracy'
      });
      tableHeaders.push({
        val: tp.toString() + '_forecast'
      });
      tableHeaders.push({
        val: tp.toString() + '_accuracy'
      });
      tableHeaders.push({
        val: tp.toString() + '_cummulative_accuracy'
      });
    }
    const tableColumns = [];
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    // console.log(finalData)


    return finalData;
  }

  get10DaysTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['toolTip'] = '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  validForecastFile(date) {
    let returnString = '';
    let currDate: any;
    if (date != null && date != undefined) {
      if (date.length == 10) {
        const Year = date[0] + date[1] + date[2] + date[3];
        const Month = date[4] + date[5];
        const DayOfMonth = date[6] + date[7];
        currDate = new Date(Year + '-' + Month + '-' + DayOfMonth);
      }
    }
    return currDate;
  }

  getWeeklyTimeStamps(value) {
    const refTs = this.validForecastFile(value);
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 6; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i) * (86400000 * 7));
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['toolTip'] = 'Week' + i.toString();
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    return date;
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }
}
